import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { useSearchParams } from 'react-router';

import { useAppSelector } from 'src/app/store/hooks';
import { DataGrid } from 'src/common/DataGrid';
import { usePaginationState } from 'src/common/DataGrid/usePaginationState';
import {
  PayersListApiArg,
  usePayersListQuery,
} from 'src/common/external/bambi-api/bambiApi';
import { useUserRoles } from 'src/features/auth/useUserRoles';

import { PayerEmptyState } from '../PayerEmptyState';
import { PayersDialog } from '../PayerForm/PayersDialog';
import { columns, manageColumn } from './columns';

export function PayerManagementRoute() {
  const payerSearchTerm = useAppSelector(
    (state) => state.payer.payerSearchTerm
  );
  const isActiveFilter = useAppSelector((state) => state.payer.filterIsActive);

  const { isRestrictedSupport } = useUserRoles();

  const orderBy = useSearchParams()[0].get(
    'ordering'
  ) as PayersListApiArg['ordering'];

  const { pagination, handlePaginationChange, paramsWithPage } =
    usePaginationState<PayersListApiArg>({
      search: payerSearchTerm,
      ordering: orderBy,
      // When false show both active/inactive
      isActive: isActiveFilter === false ? undefined : isActiveFilter,
    });

  const {
    data: payers,
    isLoading,
    isFetching,
  } = usePayersListQuery(paramsWithPage);

  return (
    <>
      {isLoading || isFetching ? (
        <div className="my-72 flex justify-center">
          <LoadingIndicator />
        </div>
      ) : (
        <>
          <div>
            <DataGrid
              tableId="payer-management"
              columns={
                isRestrictedSupport ? columns : [...columns, manageColumn]
              }
              data={payers?.results || []}
              pagination={pagination}
              totalCount={payers?.count || 0}
              handlePaginationChange={handlePaginationChange}
              emptyState={<PayerEmptyState />}
              dataTestId="payer-management-table"
              orderedBy={orderBy as string}
              getRowId={(row) => row.id}
            />
          </div>
        </>
      )}
      <PayersDialog />
    </>
  );
}
